import React, { useEffect, useRef } from 'react';
import './scss/Confetti.scss';

const Confetti = ({ isActive, onComplete, fullViewport = false }) => {
  const confettiRef = useRef(null);

  useEffect(() => {
    if (isActive) {
      // Create confetti particles
      const confettiContainer = document.createElement('div');
      confettiContainer.className = fullViewport ? 'confetti-container fullviewport' : 'confetti-container';

      const colors = ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#feca57', '#ff9ff3', '#54a0ff'];

      // Create 50 confetti pieces for full viewport, 30 for regular
      const pieceCount = fullViewport ? 50 : 30;

      for (let i = 0; i < pieceCount; i++) {
        const confettiPiece = document.createElement('div');
        confettiPiece.className = 'confetti-piece';

        // Random properties
        const color = colors[Math.floor(Math.random() * colors.length)];
        const size = Math.random() * 8 + 4; // 4-12px
        const left = Math.random() * 100; // 0-100%
        const animationDelay = Math.random() * 0.5; // 0-0.5s delay
        const animationDuration = Math.random() * 1 + 1.5; // 1.5-2.5s duration
        const rotation = Math.random() * 360; // 0-360deg

        confettiPiece.style.cssText = `
          background-color: ${color};
          width: ${size}px;
          height: ${size}px;
          left: ${left}%;
          animation-delay: ${animationDelay}s;
          animation-duration: ${animationDuration}s;
          transform: rotate(${rotation}deg);
        `;

        confettiContainer.appendChild(confettiPiece);
      }

      // Append to body for full viewport or to ref for local
      if (fullViewport) {
        document.body.appendChild(confettiContainer);
      } else if (confettiRef.current) {
        confettiRef.current.appendChild(confettiContainer);
      }

      // Auto cleanup after animation
      const cleanup = setTimeout(() => {
        if (confettiContainer && confettiContainer.parentNode) {
          confettiContainer.parentNode.removeChild(confettiContainer);
        }
        if (onComplete) {
          onComplete();
        }
      }, 3000);

      return () => {
        clearTimeout(cleanup);
        // Full-viewport confetti is attached to document.body on purpose so it
        // can outlive the component that triggered it (e.g. a card that gets
        // archived by an automation right after completion). Let its own
        // timeout finish the animation instead of tearing it down on unmount.
        if (fullViewport) {
          setTimeout(() => {
            if (confettiContainer && confettiContainer.parentNode) {
              confettiContainer.parentNode.removeChild(confettiContainer);
            }
          }, 3000);
          if (onComplete) {
            onComplete();
          }
          return;
        }
        if (confettiContainer && confettiContainer.parentNode) {
          confettiContainer.parentNode.removeChild(confettiContainer);
        }
      };
    }
  }, [isActive, onComplete, fullViewport]);

  if (!isActive) return null;

  // For full viewport, use portal to body
  if (fullViewport) {
    return null; // Handled in useEffect
  }

  // For local confetti, render container
  return (
    <div ref={confettiRef} style={{ position: 'relative', pointerEvents: 'none' }}>
      {/* Confetti pieces will be dynamically created here */}
    </div>
  );
};

export default Confetti;
